import types from '@/vuex/reencaminhamento-documento/actions-types'
import documentos from '@/utils/documentos'

const actions = {
  [types.SET_PASSO_ATUAL]: ({commit}, payload) => {
    commit(types.SET_PASSO_ATUAL, payload)
  },
  [types.SET_NUMERO_DOCUMENTO]: ({ commit }, payload) => {
    commit(types.SET_NUMERO_DOCUMENTO, payload)
  },
  [types.SET_LISTA_UNIDADES]: ({commit}, payload) => {
    commit(types.SET_LISTA_UNIDADES, payload)
  },
  [types.SET_UNIDADE]: ({commit}, payload) => {
    commit(types.SET_UNIDADE, payload)
  },
  [types.SET_LISTA_DOCUMENTOS]: ({commit}, payload) => {
    commit(types.SET_LISTA_DOCUMENTOS, payload)
  },
  [types.SET_DOCUMENTO]: ({commit}, payload) => {
    commit(types.SET_DOCUMENTO, payload)
  },

  [types.GET_LISTA_UNIDADES]: async ({ commit }) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando unidades permitidas' }, {root: true})
    try {
      const response = await documentos.getListaUnidadesReencaminhamento()
      commit(types.SET_LISTA_UNIDADES, { listaUnidades: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar a lista de unidades permitidas para reencaminhamento' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando unidades permitidas' }, {root: true})
    }
  },

  [types.GET_LISTA_DOCUMENTOS]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando documentos permitidos' }, {root: true})
    try {
      if (!payload.numeroDocumento && !payload.idUnidade) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Defina pelo menos a unidade para buscar documentos a serem reencaminhados' }, {root: true})
      } else {
        const response = await documentos.getListaDocumentosReencaminhamento(payload.idUnidade, payload.numeroDocumento)
        commit(types.SET_LISTA_DOCUMENTOS, { listaDocumentos: response.data })
      }
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar a lista de documentos permitidos para reencaminhamento' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando documentos permitidos' }, {root: true})
    }
  },

  [types.RECEBER_DOCUMENTO_PARA_REENCAMINHAMENTO]: async ({ commit }, payload) => {
    const confirmacaoCallback = async () => {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Recebendo documento' }, {root: true})
      try {
        await documentos.receberDocumentoReencaminhamento(payload.documentoSelecionado.idDocumento)
        commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documento recebido com sucesso' }, {root: true})
        payload.documentoSelecionado.situacao = 'T'
        commit(types.SET_DOCUMENTO, { documentoSelecionado: payload.documentoSelecionado })
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível receber o documento' }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Recebendo documento' }, {root: true})
      }
    }
    const config = {
      textoPergunta: 'Receber o documento?',
      textoConteudo: `Você, "${payload.servidor.nome}", receberá ${payload.documentoSelecionado.tipoDocumento} número "${payload.documentoSelecionado.numeroDocumento}" em nome de "${payload.documentoSelecionado.destino}"`,
      textoNao: 'Não',
      textoSim: 'Receber',
      confirmacaoCallback: confirmacaoCallback
    }
    commit(types.SHOW_CONFIRMATION_DIALOG, { ...config }, {root: true})
  },

  [types.REALIZAR_REENCAMINHAMENTO]: async ({ commit, dispatch }, payload) => {
    let usuarioDocumentoReencaminhado = payload.documentoSelecionado.destino
    const confirmacaoCallback = async () => {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Reencaminhando documento' }, {root: true})
      try {
        await documentos.realizarReencaminhamento(
          payload.documentoSelecionado.idDocumento,
          payload.fluxoSelecionado.id,
          payload.destinoSelecionado.id,
          payload.despacho,
          payload.despachoFormatado)
        commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documento reencaminhado com sucesso' }, {root: true})
        commit(types.SET_PASSO_ATUAL, {passoAtual: 1})
        dispatch(types.GET_LISTA_DOCUMENTOS, {idUnidade: payload.unidadeSelecionada.id})
        commit(types.SET_DOCUMENTO, {documentoSelecionado: null})
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível reencaminhar o documento' }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Reencaminhando documento' }, {root: true})
      }
    }
    const config = {
      textoPergunta: 'Reencaminhar o documento?',
      textoConteudo: `${payload.documentoSelecionado.tipoDocumento} número "${payload.documentoSelecionado.numeroDocumento}" será reencaminhado de "${usuarioDocumentoReencaminhado}" para "${payload.destinoSelecionado.nome}"`,
      textoNao: 'Não',
      textoSim: 'Reencaminhar',
      confirmacaoCallback: confirmacaoCallback
    }
    commit(types.SHOW_CONFIRMATION_DIALOG, { ...config }, {root: true})
  }
}

export default actions
